import React from "react";
import { Link, useParams } from "react-router-dom";
import { usePolygonHole } from "../../../../components/SiteMap/contexts/PolygonHoleContext";
import SiteMapSurfaceRoute from "../../../../components/SiteMap/routes/SurfaceRoute";
import { useData } from "../../../../components/SiteMap/contexts/DataContext";
import { PortalButtonHeader } from "./Default";
import { useMapEditing } from "../../../../components/SiteMap/utils/routing";

const SiteMapSurfacePage = () => {
  const { surfaceId } = useParams();
  const { surfaceFeatures } = useData();
  const surface = surfaceFeatures.find(
    (feature) => surfaceId && feature.id === parseInt(surfaceId),
  );
  const { editing, setEditing } = useMapEditing();

  const { shouldCutHole, setShouldCutHole } = usePolygonHole();
  const toggleHoleCutting = () => {
    setShouldCutHole(!shouldCutHole);
  };

  return (
    <>
      {!editing && (
        <PortalButtonHeader>
          <Link to="export">
            <button className="px-6 py-2.5 rounded-xl font-bold text-sm cursor-pointer bg-snow-gray hover:opacity-80 active:opacity-40 mr-4">
              Export Map
            </button>
          </Link>
          <button
            onClick={() => setEditing(true, "/surface/" + surfaceId)}
            className="px-6 py-2.5 rounded-xl font-bold text-snow-white text-sm cursor-pointer bg-snow-blue-3 hover:opacity-80 active:opacity-40"
          >
            Edit
          </button>
        </PortalButtonHeader>
      )}
      <SiteMapSurfaceRoute
        surface={surface}
        shouldCutHole={shouldCutHole}
        toggleHoleCutting={toggleHoleCutting}
      />
    </>
  );
};

export default SiteMapSurfacePage;
